import React from 'react'
//table
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import WriteLog from '../Globals/WriteLog';




function StyledStatusCell({status, desc, id, onclick}){

    WriteLog("StyledStatusCell->id", id);


    const StyledTableCellRed = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: "#ed6666",
          color: theme.palette.common.black,          
        },
        [`&.${tableCellClasses.body}`]: {          
          border:'3px solid #FFF',
          backgroundColor: "#ed6666",
          color: theme.palette.common.white,          

        },
        [`&.${tableCellClasses.root}`]: {            
            border:'3px solid #FFF'
          },
      }));      
      const StyledTableCellGreen = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: "#DDD",
          color: theme.palette.common.black,          
        },
        [`&.${tableCellClasses.body}`]: {          
          border:'3px solid #FFF',
          backgroundColor: "#24a33f",
          color: theme.palette.common.white,          

        },
        [`&.${tableCellClasses.root}`]: {            
            border:'3px solid #FFF'
          },
      }));

      const StyledTableCellPurpul = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: "#DDD",
          color: theme.palette.common.black,          
        },
        [`&.${tableCellClasses.body}`]: {          
          border:'3px solid #FFF',
          backgroundColor: "#9454c4",
          color: theme.palette.common.white,          

        },
        [`&.${tableCellClasses.root}`]: {            
            border:'3px solid #FFF'
          },
      }));

      const StyledTableCellGray = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: "#DDD",
          color: theme.palette.common.black,          
        },
        [`&.${tableCellClasses.body}`]: {          
          border:'3px solid #FFF',
          backgroundColor: "#AAA",
          color: theme.palette.common.white,          

        },
        [`&.${tableCellClasses.root}`]: {            
            border:'3px solid #FFF'
          },
      }));      
      const StyledTableCellOrange = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: "#FF7B54",
          color: theme.palette.common.black,   
          height:60              
        },
        [`&.${tableCellClasses.body}`]: {          
          border:'3px solid #FFF',
          backgroundColor: "#FF7B54",
          color: theme.palette.common.white,   
          height:50,
          padding:0,
          margin:0
        },
        [`&.${tableCellClasses.root}`]: {            
          border:'3px solid #FFF',            
        },
        [`&.${tableCellClasses.root}`]: {            
            border:'3px solid #FFF'
          },
      }));


  if(status === 0)
  return (    
      <StyledTableCellOrange align="center">
          <div className=" flex text-white h-full hover:bg-orange-600 hover:text-white cursor-pointer items-center text-center" onClick={(e)=>onclick(e,id)}>
              <div className='text-center w-full'>{desc}</div>
          </div> 
      </StyledTableCellOrange>        
  )
  if(status === 1)
  return (    
    <StyledTableCellGreen align="center">{desc}</StyledTableCellGreen>    
  )
  if(status === 2)
  return (    
    <StyledTableCellRed align="center">{desc}</StyledTableCellRed>    
  )
  if(status === 3)
  return (    
    <StyledTableCellPurpul align="center">{desc}</StyledTableCellPurpul>    
  )
  if(status === 4)
  return (    
    <StyledTableCellGray align="center">{desc}</StyledTableCellGray>    
  )
}

export default StyledStatusCell